/** Rendering the page: each view the checkout shows, in the browser's document. */
import { render } from "preact";
import { Page } from "./Page.tsx";
import { type View, withLang } from "./pay.ts";

/**
 * Shows each view in `root`, in its language: another language is this address in it (`here`, the browser's), starting
 * again is loading it again.
 */
export function mount(root: HTMLElement, appUrl: string, here: Location): (view: View) => void {
  return (view) => {
    document.documentElement.lang = view.lang;
    render(
      <Page
        view={view}
        appUrl={appUrl}
        onLang={(lang) => here.replace(withLang(here.href, lang))}
        onAgain={() => here.reload()}
      />,
      root,
    );
  };
}
